import { RolesListComponent } from './roles-list.component';
import { CommonModule } from '@angular/common';
import { rolesListRouting } from './roles-list.routing';
import { SharedModule } from '../../../core/shared/shared.module';
import { NgModule } from '@angular/core';
import { LoginRest } from '../../../login/login.rest';
import { RoleDetailsModule } from '../role-details/role-details.module';
import { RoleModalComponent } from '../role-modal-add/role-modal-add.component';

@NgModule({
    imports: [
      CommonModule,
      rolesListRouting,
      SharedModule,
      RoleDetailsModule
    ],  
    declarations: [RolesListComponent, RoleModalComponent],
    exports: [],
    providers : [LoginRest]
  })
  export class RolesListModule { }